<template>
  <span
    v-if="value !== null && value !== undefined"
    class="px-1.5 py-0.5 rounded-full text-xs font-medium"
    :class="tone"
    title="The run model's confidence, 0-100"
  >{{ value }}</span>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({ value: { type: Number, default: null } })

// The run's bands: 85+ it accepts on its own; 50-84 it sends to review.
const tone = computed(() => {
  if (props.value >= 85) return 'bg-green-100 text-green-800'
  if (props.value >= 68) return 'bg-indigo-100 text-indigo-800'
  if (props.value >= 50) return 'bg-amber-100 text-amber-800'
  return 'bg-gray-100 text-gray-600'
})
</script>
